<template>
  <vue-tree-list @click="onClick" @change-name="onChangeName" @delete-node="onDel" @add-node="onAddNode"
                 @drop="onDrop" @drop-before="onDropBefore" @drop-after="onDropAfter"
                 :model="data" :loading="loading"
                 default-tree-node-name="子模版" default-leaf-node-name="子模版" v-bind:default-expanded="false"
                 style="font-size: 15px;">
    <template v-slot:leafNameDisplay="slotProps">
      <Checkbox v-if="slotProps.model.showCheckbox" :label="slotProps.model.id"  :disabled="slotProps.model.disabled" v-model="slotProps.model.checked">{{ slotProps.model.name }}</Checkbox>
      <span v-else>{{slotProps.model.name}}</span>
    </template>
    <span class="icon" slot="addLeafNodeIcon">
      <Icon type="md-add"/>
    </span>
    <span class="icon" slot="editNodeIcon">
      <Icon type="ios-create-outline"/>
    </span>
    <span class="icon" slot="delNodeIcon">
      <Icon type="md-close"/>
    </span>
  </vue-tree-list>
</template>

<script>
import {VueTreeList, Tree, TreeNode} from 'vue-tree-list'

export default {
  name: "Tree",
  props: {
    value: {
      type:Array,
      default: () => {
        return []
      }
    },
  },
  components: {
    VueTreeList,
  },
  data() {
    return {
      loading: true,
      data: new Tree([]),
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal){
          console.log("树状数据:",newVal)
          newVal = this.setPropertiesInArray(newVal,false);
          this.data = new Tree(newVal)
          console.log(newVal)
          this.loading = false;
        }
      }
    }, deep: true
  },
  methods: {
    setPropertiesInArray(array,isLeft){
      if (array){
        array.forEach(item => {
          item.addTreeNodeDisabled = true
          item.addLeafNodeDisabled = true
          item.editNodeDisabled = true
          item.delNodeDisabled = true
          item.dragDisabled = true
          if (!item.name && item.title){
            item.name = item.title
          }
          item.isLeaf=isLeft
          item.showCheckbox = true;
          if (item.isLisProject && isLeft){
            item.showCheckbox = false;
          }
          if (item.children){
            item.isLeaf=false
            item.children = this.setPropertiesInArray(item.children,true);
          }
        })
        return array;
      }
      return [];
    },
    onDel(node) {
      node.remove()
      this.$emit("onDel", node)
    },
    onChangeName(params) {
      this.$emit("onChangeName", params)
    },
    onAddNode(params) {
      this.$emit("onAddNode", params)
    },
    onClick(params) {
      if (params.parent.name !== 'root') {
        this.$emit("onClick", params)
      }
    },
    /**
     * 树节点拖拽相关方法
     * */
    onDrop(params) {
      this.$emit("onDrop", params)
    },
    onDropBefore(params) {
      this.$emit("onDropBefore", params)
    },
    onDropAfter(params) {
      this.$emit("onDropBefore", params)
    },
  }
}
</script>

<style lang="less" rel="stylesheet/less">
.vtl {
  margin-left: 20px;

  .vtl-drag-disabled {
    background-color: #fff;

    &:hover {
      background-color: #d0cfcf;
    }
  }

  .vtl-disabled {
    background-color: #fff;
  }
}
</style>

<style lang="less" rel="stylesheet/less" scoped>
.icon {
  &:hover {
    cursor: pointer;
  }
}

.muted {
  color: gray;
  font-size: 80%;
}
</style>
